import http from '@/axios/index';

/**
 * @description: 获取模板
 */
export function get_domain(data={}) {
    return http.request({
        url: '/get_domain',
        method: 'POST',
        data: data
    });
}

/**
 * @description: 获取模板
 */
export function get_sys_config(data={}) {
    return http.request({
        url: '/sys_config',
        method: 'POST',
        data: data
    });
}